// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1pZll","delete":"styles_delete__11yWe","update":"styles_update__Gl7a0","add":"styles_add__1Sd0w"};